import React from "react";

interface Props {
  icon: React.ReactNode;
  title: string;
  value: string | number;
  subtitle?: string;
  tone?: "dark" | "yellow" | "green" | "blue" | "red";
}

const toneClass = {
  dark: "aida-kpi-icon-dark",
  yellow: "aida-kpi-icon-yellow",
  green: "aida-kpi-icon-green",
  blue: "aida-kpi-icon-blue",
  red: "aida-kpi-icon-red",
};

const CartographyKpiCard: React.FC<Props> = ({ icon, title, value, subtitle, tone = "yellow" }) => {
  return (
    <div className="aida-kpi-card h-100">
      <div className={`aida-kpi-icon ${toneClass[tone]}`}>{icon}</div>
      <div className="aida-kpi-content">
        <div className="aida-kpi-title">{title}</div>
        <div className="aida-kpi-value">{value}</div>
        {subtitle && <div className="aida-kpi-subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

export default CartographyKpiCard;
